import React, { Fragment, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import {
  Typography,
  ExpansionPanel,
  Grid,
  Divider,
  Button,
  Switch,
  FormControl,
  FormGroup,
  FormHelperText,
  FormControlLabel,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import CheckIcon from "@material-ui/icons/Check";
import { green } from "@material-ui/core/colors";
import Fichiers from "example-components/FormsControls/FormsControlsCreationBesc/pages/Files";
import Groupage from "example-components/FormsControls/FormsControlsCreationBesc/pages/Groupage";
import Chargeurs from "example-components/FormsControls/FormsControlsCreationBesc/pages/Chargeurs";
import Fournisseur from "example-components/FormsControls/FormsControlsCreationBesc/pages/Fournisseur";
import Cargaison from "example-components/FormsControls/FormsControlsCreationBesc/pages/Cargaison";
import Transport from "example-components/FormsControls/FormsControlsCreationBesc/pages/Transport";
import Transactions from "example-components/FormsControls/FormsControlsCreationBesc/pages/Transactions";
import { makeStyles } from "@material-ui/core/styles";
import { notify, closeSnack, formatError } from "utils/MyFunctions";
import userContext from "contexts/userContext";
import feedbackContext from "contexts/feedbackContext";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import _, { debounce } from "lodash";
const LivePreviewExample = (props) => {
  const intl = useIntl();
  //const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
  const history = useHistory();
  //DECLARATIONS
  const MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;
  const [requestOptions, setRequestOptions] = React.useState([
    {
      method: "GET",
      redirect: "follow",
      headers: {
        Accept: "application/ld+json",
      },
    },
  ]);
  const [fileProgress, setFileProgress] = React.useState(0);

  const phoneClean = (phone) => {
    let res = phone.replace(/[^\d]/g, "");
    return res.substr(0, 2) === "00" ? res.slice(2) : res;
  };

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const { role, setRole, locale } = useContext(userContext);
  const [tempRef, setTempRef] = React.useState("");
  const [reference, setReference] = React.useState("");
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext,
  );

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      background: "none",
      position: "relative",
      zIndex: theme.zIndex.drawer + 1,
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const [afl, setAfl] = React.useState(false);

  const [loading, setLoading] = React.useState(false);

  const [refError, setRefError] = React.useState(false);
  const [refOK, setRefOK] = React.useState(false);

  const [refHelper, setRefHelper] = React.useState("");

  const [expanded, setExpanded] = React.useState(false);
  const [filesFilled, setFilesFilled] = React.useState(false);
  const [conditionnement, setConditionnement] = React.useState("");
  const [carrier, setCarrier] = React.useState("");
  const [groupingFilesFilled, setGroupingFilesFilled] = React.useState(false);
  const [transactionsFilled, setTransactionsFilled] = React.useState(false);
  const [chargeursFilled, setChargeursFilled] = React.useState(false);
  const [fournisseurFilled, setFournisseurFilled] = React.useState(false);
  const [cargaisonFilled, setCargaisonFilled] = React.useState(false);
  const [transportFilled, setTransportFilled] = React.useState(false);

  const [filesLoading, setFilesLoading] = React.useState(false);
  const [groupingFilesLoading, setGroupingFilesLoading] = React.useState(false);
  const [transactionsLoading, setTransactionsLoading] = React.useState(false);
  const [shippersLoading, setShippersLoading] = React.useState(false);
  const [cargaisonLoading, setCargaisonLoading] = React.useState(false);
  const [transportLoading, setTransportLoading] = React.useState(false);

  const [chargeurs, setChargeurs] = React.useState([]);
  const [createMode, setCreateMode] = React.useState({
    chargeur: null,
    fournisseur: false,
    navire: false,
    transporteur: false,
  });
  const [groupingFile, setGroupingFile] = React.useState({});
  const [transactions, setTransactions] = React.useState([]);
  const [b64, setB64] = React.useState([]);
  const [fichiers, setFichiers] = React.useState([]);
  const [b64Group, setB64Group] = React.useState([]);
  const [fch, setFch] = React.useState([]);
  const [files, setFiles] = React.useState({});
  const [filesCopy, setFilesCopy] = React.useState();
  const [fournisseur, setFournisseur] = React.useState({});
  const [marchandise, setMarchandise] = React.useState({});
  const [detailsConteneur, setDetailsConteneur] = React.useState([]);
  const [detailsChassis, setDetailsChassis] = React.useState([]);
  const [SH, setSH] = React.useState([]);
  const [transport, setTransport] = React.useState({});
  const [partnersData, setPartnersData] = React.useState([]);
  const [hasRef, setHasRef] = React.useState(false);
  const [isGroup, setIsGroup] = React.useState(false);
  const [checkingRef, setCheckingRef] = React.useState(false);
  const [received22, setReceived22] = React.useState(false);
  const debounceCheckRef = _.debounce(async (ref) => {
    try {
      setCheckingRef(true);
      const response = await fetch(
        MONOLITH_API_URL + "/api/extra_references?ref=" + ref,
        requestOptions,
      );
      setCheckingRef(false);

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      console.log("reponse json : ", _shippers);
      if (
        _shippers.length > 0 &&
        _shippers[0].user === "/api/users/" + role.user["unique_identification"]
      ) {
        console.log("REFERENCE FOUND");
        if (_shippers[0].isUsed) {
          console.log("Reference is already used");
          //USED
          setRefError(true);
          setRefHelper("Numéro de référence déjà utilisé");
          setRefOK(false);
        } else {
          console.log("reference : ", _shippers[0]);
          //FOUND
          setRefError(false);
          setRefHelper("");
          setRefOK(true);
          setTempRef("/api/extra_references/" + _shippers[0].id);
        }
      } else {
        setRefOK(false);
        //NOT FOUND
        console.log("NOT FOUND");
        setRefError(true);
        setRefHelper("Numéro de référence introuvable");
      }
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [jsonData, setJsonData] = React.useState();
  const [besc, setBesc] = React.useState({});

  const fName = (filename) => {
    return (
      filename.filePath.substring(0, filename.filePath.lastIndexOf("-")) +
      filename.filePath.substring(filename.filePath.lastIndexOf("."))
    );
  };

  const handleChangeRef = (event) => {
    event.persist(event);
    console.log("Changing reference to ...");
    setReference(event.target.value);
  };

  useEffect(() => {
    console.log("reference changed (PARENT), reference : ", reference);
    if (reference.length > 8) {
      debounceCheckRef(reference);
    } else {
      setRefOK(false);
    }
  }, [reference]);

  useEffect(() => {
    console.log("isGroup changed (PARENT), isGroup : ", isGroup);
  }, [isGroup]);

  useEffect(() => {
    console.log("filesCopy changed (PARENT), filesCopy : ", filesCopy);
  }, [filesCopy]);

  useEffect(() => {
    console.log("createMode changed (PARENT), createMode : ", createMode);
  }, [createMode]);

  useEffect(() => {
    console.log("tempRef changed (PARENT), tempRef : ", tempRef);
  }, [tempRef]);

  useEffect(() => {
    console.log("groupingFile changed (PARENT), groupingFile : ", groupingFile);
  }, [groupingFile]);

  useEffect(() => {
    console.log(
      "chargeursFilled changed (PARENT), chargeursFilled : ",
      chargeursFilled,
    );
  }, [chargeursFilled]);

  useEffect(() => {
    console.log("MONOLITH_API_URL : ", MONOLITH_API_URL);
    console.log("Creation props : ", props);
    let _chargeurs = [];
    let _detailsConteneur = [];
    let _detailsChassis = [];
    let _SH = [];
    let _transactions = [];
    let bescs;
    setLoading(false);

    if (props.bescId) {
      (async () => {
        setFilesLoading(true);
        setCargaisonLoading(true);
        setShippersLoading(true);
        setTransportLoading(true);
        setTransactionsLoading(true);
        const b = await fetch(MONOLITH_API_URL + "/api/bescs/" + props.bescId, {
          method: "GET",
          redirect: "follow",
          headers: {
            Accept: "application/ld+json",
            Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
          },
        });
        bescs = await b.json();

        console.log(
          "*******************************************result show id : ",
          props.bescId,
          "  ",
          bescs,
        );
        setBesc(bescs);
        props.setNumber(bescs.number ? bescs.number : bescs.demande);
        if (
          bescs.referenceDocChildNumber &&
          bescs.refDocChildFile &&
          bescs.refDocChildFile.filename
        ) {
          setIsGroup(true);
          setGroupingFile({
            name: bescs.refDocChildFile.filename,
            bl: bescs.referenceDocChildNumber,
            b64: bescs.refDocChildFile.data,
          });
        }
        let _files = [];
        _files.push({
          types: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_ref",
          ),
          nom: bescs.refDocFile.filename,
          blob: bescs.refDocFile.data,
        });
        _files.push({
          types: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_commercial",
          ),
          nom: bescs.commercialFile.filename,
          blob: bescs.commercialFile.data,
        });
        _files.push({
          types: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_fret",
          ),
          nom: bescs.fretFile.filename,
          blob: bescs.fretFile.data,
        });
        if (bescs.packingListFile && bescs.packingListFile.filename) {
          _files.push({
            types: formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_select_packing_list",
            ),
            nom: bescs.packingListFile.filename,
            blob: bescs.packingListFile.data,
          });
        }
        if (
          bescs.originCertificateFile &&
          bescs.originCertificateFile.filename
        ) {
          _files.push({
            types: formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_select_certificate_origin",
            ),
            nom: bescs.originCertificateFile.filename,
            blob: bescs.originCertificateFile.data,
          });
        }
        if (
          bescs.exoneration &&
          bescs.exoneration.exonerationFile &&
          bescs.exoneration.exonerationFile.filename
        ) {
          _files.push({
            types: formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_exoneration",
            ),
            nom: bescs.exoneration.exonerationFile.filename,
            blob: bescs.exoneration.exonerationFile.data,
          });
        }
        if (
          bescs.specialAuthorisationFile &&
          bescs.specialAuthorisationFile.filename
        ) {
          _files.push({
            types: formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_special_authorization",
            ),
            nom: bescs.specialAuthorisationFile.filename,
            blob: bescs.specialAuthorisationFile.data,
          });
        }
        for (let i = 0; i < bescs.otherFiles.length; i++) {
          _files.push({
            types: formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_select_other",
            ),
            nom: bescs.otherFiles[i].filename,
            blob: bescs.otherFiles[i].data,
          });
        }

        setFiles(_files);
        setFilesCopy(_files);
        setFilesLoading(false);

        //FETCHING TRANSACTIONS

        for (let t of bescs["commercialTransactions"]) {
          _transactions.push({
            transaction: t.numeroTransaction,
            contribuable: t.numeroContribuable,
          });
        }

        setTransactions(_transactions);

        setTransactionsLoading(false);

        //SETTING UP CARGO
        setMarchandise({
          cond: bescs.conditionnement,
          cvalue: bescs.cargo.invoiceValue,
          ccurrency: bescs.cargo.invoiceValueCur,
          fvalue: bescs.cargo.fobValue,
          fcurrency: bescs.cargo.invoiceValueCur,
          nbcont20: bescs.cargo.numberOfContainerTwenty,
          nbcont40: bescs.cargo.numberOfContainerFourty,
          nbmotos: bescs.cargo.numberOfMotos,
          poids: bescs.cargo.weight,
          volume: bescs.cargo.volume,
          nbchassis: bescs.cargo.vehicles.length.toString(),
          nbcolis: bescs.cargo.numberOfPkgs,
          description: bescs.cargo.description,
          typeMarchandise: bescs.classeTarifaire,
        });

        //SETTING UP CONTAINERS
        for (let c of bescs.cargo.containers) {
          _detailsConteneur.push(
            props.bescId
              ? {
                  id: c.id,
                  ncont: c.number,
                  taille: c.size,
                  nplomb: c.seal,
                  type: c.type,
                  chargement: c.loading,
                  poids: c.vgm,
                  contenu: c.content,
                }
              : {
                  ncont: c.number,
                  taille: c.size,
                  nplomb: c.seal,
                  type: c.type,
                  chargement: c.loading,
                  poids: c.vgm,
                  contenu: c.content,
                },
          );
        }
        console.log("DETAILS CONTENEUR : ", _detailsConteneur);
        setDetailsConteneur(_detailsConteneur);
        setReceived22(true);

        //SETTING UP CHASSIS
        for (let v of bescs.cargo.vehicles) {
          _detailsChassis.push(
            props.bescId
              ? {
                  id: v.id,
                  nchassis: v.chassisNumber,
                  marque: "",
                  modele: v.model,
                  cartegrise: v.grayCard ? v.grayCard.filename : null,
                  b64: v.grayCard ? v.grayCard.data : null,
                  contenu: v.content,
                  annee: v.dateOfCirculation
                    ? v.dateOfCirculation.substring(0, 10)
                    : "",
                }
              : {
                  nchassis: v.chassisNumber,
                  marque: "",
                  modele: v.model,
                  cartegrise: v.grayCard ? v.grayCard.filename : null,
                  b64: v.grayCard ? v.grayCard.data : null,
                  contenu: v.content,
                  annee: v.dateOfCirculation
                    ? v.dateOfCirculation.substring(0, 10)
                    : "",
                },
          );
        }
        setDetailsChassis(_detailsChassis);

        //SETTING UP SH
        for (let v of bescs.cargo.products) {
          let _desc = "";

          let response = await fetch(
            MASTER_API_URL + "/api/hs_codes?code=" + v.hsCode,
            {
              method: "GET",
              redirect: "follow",
              headers: {
                Accept: "application/ld+json",
                "Accept-Language": locale,
              },
            },
          );
          let _s = await response.json();

          _desc = _s["hydra:member"];
          if (_desc.length > 0) {
            _desc = _desc[0].description;
          }

          _SH.push(
            props.bescId
              ? {
                  id: v.id,
                  code: v.hsCode,
                  desc: _desc,
                  products: v.libelle,
                  weight: v.weight,
                  value: v.value,
                  curr: v.valueCur ? v.valueCur : "USD",
                }
              : {
                  code: v.hsCode,
                  desc: _desc,
                  products: v.libelle,
                  weight: v.weight,
                  value: v.value,
                  curr: v.valueCur ? v.valueCur : "USD",
                },
          );
        }

        setSH(_SH);
        setCargaisonLoading(false);

        //FETCHING CHARGEURS

        if (bescs.consignees.length > 0) {
          let ch = bescs["consignees"][0];
          console.log("BESC SHIPPER : ", bescs.shipper);
          console.log("BESC CONSIGNEE 0 : ", ch);
          let _uuid = bescs.shipper ? bescs.shipper : ch.uuid;

          if (props.sens === "transit") {
            let response = await fetch(
              MASTER_API_URL + "/api/foreign_shippers?uuid=" + _uuid,
              requestOptions,
            );

            //await sleep(1e3); // For demo purposes.
            let _shippers = await response.json();
            if (_shippers.length > 0) {
              let s = _shippers[0];

              let _respT = await fetch(MASTER_API_URL + s.town);
              let __town = await _respT.json();
              let _respC = await fetch(MASTER_API_URL + s.country);
              let __country = await _respC.json();

              setChargeurs({
                uuid: s.uuid,
                nom: s.name,
                tel: s.phone,
                email: s.email,
                adresse: s.address,
                ville: __town.name + ", " + __country.name,
              });
            }
          } else {
            let response = await fetch(
              MASTER_API_URL + "/api/shipper_aliases?uuid=" + _uuid,
              requestOptions,
            );

            //await sleep(1e3); // For demo purposes.
            let _shippers = await response.json();
            if (_shippers.length > 0) {
              let s = _shippers[0];

              let _respT = await fetch(MASTER_API_URL + s.town);
              let __town = await _respT.json();
              let _respC = await fetch(MASTER_API_URL + s.country);
              let __country = await _respC.json();
              _chargeurs.push(
                props.bescId
                  ? {
                      id: s.id,
                      uuid: s.uuid,
                      nom: s.name,
                      niu: s.taxpayer_number,
                      tel: s.phone,
                      email: s.email,
                      adresse: s.address,
                      ville: __town.name + ", " + __country.name,
                    }
                  : {
                      uuid: s.uuid,
                      nom: s.name,
                      niu: s.taxpayer_number,
                      tel: s.phone,
                      email: s.email,
                      adresse: s.address,
                      ville: __town.name + ", " + __country.name,
                    },
              );

              setChargeurs(_chargeurs);
            }
          }
        }

        //FETCHING FOURNISSEURS
        let fs = await fetch(
          MASTER_API_URL + "/api/foreign_shippers?uuid=" + bescs.foreignShipper,
          requestOptions,
        );

        //await sleep(1e3); // For demo purposes.
        let _fournisseur = await fs.json();

        if (_fournisseur.length > 0) {
          let f = _fournisseur[0];

          let respT = await fetch(MASTER_API_URL + f.town);
          let _town = await respT.json();
          let respC = await fetch(MASTER_API_URL + f.country);
          let _country = await respC.json();

          setFournisseur({
            uuid: f.uuid,
            nom: f.name,
            tel: f.phone,
            email: f.email,
            adresse: f.address,
            ville: _town.name + ", " + _country.name,
          });
        }

        setShippersLoading(false);

        //FETCHING TRANSPORTEUR

        let _carrier = await fetch(
          MASTER_API_URL + "/api/carriers?uuid=" + bescs.carrier,
          requestOptions,
        );
        _carrier = await _carrier.json();

        _carrier = _carrier[0];
        //FETCHING NAVIRE
        let _vessel = await fetch(
          MASTER_API_URL + "/api/vessels?uuid=" + bescs.vessel,
          requestOptions,
        );
        _vessel = await _vessel.json();
        _vessel = _vessel[0];

        //FETCHING COUNTRY OF LOADING
        let _cl = await fetch(
          MASTER_API_URL + "/api/countries?code=" + bescs.countryOfLoading,
          {
            method: "GET",
            redirect: "follow",
            headers: {
              Accept: "application/ld+json",
              "Accept-Language": locale,
            },
          },
        );
        _cl = await _cl.json();
        _cl = _cl["hydra:member"][0];

        //FETCHING COUNTRY OF ORIGIN
        let _co = await fetch(
          MASTER_API_URL + "/api/countries?code=" + bescs.countryOfOrigin,
          {
            method: "GET",
            redirect: "follow",
            headers: {
              Accept: "application/ld+json",
              "Accept-Language": locale,
            },
          },
        );
        _co = await _co.json();
        _co = _co["hydra:member"][0];

        //FETCHING COUNTRY OF TRANSIT
        let _ct;
        if (props.sens === "transit") {
          _ct = await fetch(
            MASTER_API_URL + "/api/countries?code=" + bescs.countryOfTransit,
            {
              method: "GET",
              redirect: "follow",
              headers: {
                Accept: "application/ld+json",
                "Accept-Language": locale,
              },
            },
          );
          _ct = await _ct.json();
          _ct = _ct["hydra:member"][0];
        }

        //FETCHING COUNTRY OF DISCHARGE
        let _cd = await fetch(
          MASTER_API_URL + "/api/countries?code=" + bescs.countryOfDischarge,
          {
            method: "GET",
            redirect: "follow",
            headers: {
              Accept: "application/ld+json",
              "Accept-Language": locale,
            },
          },
        );
        _cd = await _cd.json();
        _cd = _cd["hydra:member"][0];

        //FETCHING PORT OF LOADING
        let _pl = await fetch(
          MASTER_API_URL + "/api/town_functions?code=" + bescs.portOfLoading,
          requestOptions,
        );
        _pl = await _pl.json();

        _pl = _pl[0];

        //FETCHING FINAL DESTINATION
        let _fd = await fetch(
          MASTER_API_URL + "/api/towns?code=" + bescs.finalDestination,
          requestOptions,
        );
        _fd = await _fd.json();

        _fd = _fd[0];

        //FETCHING PORT OF DISCHARGE
        let _pd = await fetch(
          MASTER_API_URL + "/api/town_functions?code=" + bescs.portOfDischarge,
          requestOptions,
        );
        _pd = await _pd.json();

        _pd = _pd[0];

        //SETTING UP TRANSPORT
        console.log("set transport start(PARENT)");
        setTransport({
          transporteur: _carrier,
          navire: _vessel,
          connaissement: bescs.referenceDocNumber,

          numVoyage: bescs.voyage,
          dateEmbarquement: bescs.loadedAt.substring(0, 10),
          dateEstArrivee: bescs.eta.substring(0, 10),
          destinationFinale: {
            code: _fd.code,
            country: _fd.country,
            countryCode: _fd.countryCode,
            pays: _fd.countryName,
            ville: _fd.name,
            uuid: _fd.uuid,
          },
          paysOrigine: _co,
          // paysTransit: _ct,
          portEmbarquement: _pl,
          portDebarquement: _pd,
          incoterm: bescs.incoterm,
          fret: bescs.freight,
          deviseFret: bescs.freightCur,
          assurance: bescs.insurance,
          deviseAssurance: bescs.insuranceCur,
          supp: bescs.fraisSup,
          deviseSupp: bescs.fraisSupCur,
          baf: bescs.baf,
          deviseBaf: bescs.bafCur,
          caf: bescs.caf,
          deviseCaf: bescs.cafCur,
          thc: bescs.thc,
          deviseTHC: bescs.thcCur,
        });
        setTransportLoading(false);
      })();
    }
  }, []);

  const createShipper = async () => {
    console.log("createMode : ", createMode);
    console.log("chargeurs : ", chargeurs);
    //LES CHARGEURS
    if (createMode.chargeur) {
      let _return = {};

      let _message = formatMessage(
        intl,
        "create_besc_maritime_import_notify_creating_shipper",
      );
      let sb = notify(
        _message,
        "info",
        "center",
        "bottom",
        false,
        enqueueSnackbar,
      );
      let _value = {};
      let _ch = { ...chargeurs[0] };

      _value.name = _ch.nom;
      _value.email = _ch.email;
      _value.phone = phoneClean(_ch.tel);
      _value.address = _ch.adresse;
      _value.country = _ch.ville.countryId;
      _value.town = _ch.ville.id;
      if (_ch.niu !== "") {
        _value.taxpayerNumber = _ch.niu;
      }

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: MASTER_API_URL + "/api/shipper_aliases",

        headers: {
          "Content-Type": "application/json",
        },

        data: _value,
      };

      try {
        let resp = await axios.request(config);
        console.log("sucess!! response below :");
        console.log(JSON.stringify(resp.data));
        closeSnackbar(sb);
        notify(
          formatMessage(
            intl,
            "create_besc_maritime_import_notify_success_shipper",
          ),
          "success",
          "center",
          "bottom",
          true,
          enqueueSnackbar,
        );
        return resp.data;
      } catch (error) {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnackbar(sb);
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setLoading(false);
        // setOpen(false);
      }
    }
  };

  const createShipperTransit = async () => {
    console.log("createMode : ", createMode);
    console.log("chargeurs : ", chargeurs);
    //LE CHARGEUR
    if (createMode.chargeur) {
      console.log("CREATION DU CHARGEUR ...");
      let _return = {};

      let _message = formatMessage(
        intl,
        "create_besc_maritime_import_notify_creating_shipper",
      );
      let sb = notify(
        _message,
        "info",
        "center",
        "bottom",
        false,
        enqueueSnackbar,
      );
      let _value = {};
      let _ch = { ...chargeurs };

      _value.name = _ch.nom;
      _value.email = _ch.email;
      _value.phone = phoneClean(_ch.tel);
      _value.address = _ch.adresse;
      _value.country = _ch.ville.countryId;
      _value.town = _ch.ville.id;

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: MASTER_API_URL + "/api/foreign_shippers",

        headers: {
          "Content-Type": "application/json",
        },

        data: _value,
      };

      try {
        let resp = await axios.request(config);
        console.log("sucess!! response below :");
        console.log(JSON.stringify(resp.data));
        closeSnackbar(sb);
        notify(
          formatMessage(
            intl,
            "create_besc_maritime_import_notify_success_shipper",
          ),
          "success",
          "center",
          "bottom",
          true,
          enqueueSnackbar,
        );
        return resp.data;
      } catch (error) {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnackbar(sb);
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setLoading(false);
        // setOpen(false);
      }
    }
  };

  const createForeignShipper = async () => {
    console.log("createMode : ", createMode);
    console.log("fournisseur : ", fournisseur);
    //LE FOURNISSEUR
    if (createMode.fournisseur) {
      console.log("CREATION DU FOURNISSEUR ...");
      let _return = {};

      let _message = formatMessage(
        intl,
        "create_besc_maritime_import_notify_creating_foreign_shipper",
      );
      let sb = notify(
        _message,
        "info",
        "center",
        "bottom",
        false,
        enqueueSnackbar,
      );
      let _value = {};
      let _ch = { ...fournisseur };

      _value.name = _ch.nom;
      _value.email = _ch.email;
      _value.phone = phoneClean(_ch.tel);
      _value.address = _ch.adresse;
      _value.country = _ch.ville.countryId;
      _value.town = _ch.ville.id;

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: MASTER_API_URL + "/api/foreign_shippers",

        headers: {
          "Content-Type": "application/json",
        },

        data: _value,
      };

      try {
        let resp = await axios.request(config);
        console.log("sucess!! response below :");
        console.log(JSON.stringify(resp.data));
        closeSnackbar(sb);
        notify(
          formatMessage(
            intl,
            "create_besc_maritime_import_notify_success_foreign_shipper",
          ),
          "success",
          "center",
          "bottom",
          true,
          enqueueSnackbar,
        );
        return resp.data;
      } catch (error) {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnackbar(sb);
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setLoading(false);
        // setOpen(false);
      }
    }
  };

  const submitForm = async () => {
    let _data = {
      refDocFile: "",
      createdBy: "",
      commercialFile: "",
      fretFile: "",
      otherFiles: [],
      referenceDocNumber: " ",
      consignees: [],
      commercialTransactions: [],
      foreignShipper: "",
      shipper: "",
      // forwardingAgent: "",
      carrier: " ",
      countryOfLoading: " ",
      portOfLoading: " ",
      countryOfDischarge: " ",
      portOfDischarge: " ",
      finalDestination: "",
      loadedAt: "2024-01-24T06:21:19.896Z",
      dischargedAt: "2024-01-24T16:32:15.632Z",
      eta: "2024-01-24T06:21:19.896Z",
      etd: "2024-01-24T16:32:15.632Z",
      incoterm: " ",
      voyage: " ",
      freight: "string",
      freightCur: "string",
      insurance: "string",
      insuranceCur: "string",
      baf: "string",
      tempRef: "",
      referenceDocChildNumber: "",
      refDocChildFile: "",
      bafCur: "string",
      caf: "string",
      cafCur: "string",
      thc: "string",
      thcCur: "string",
      fraisSup: "string",
      fraisSupCur: "string",
      classeTarifaire: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      // countryOfTransit: "string",
      tarificationZone: "non defini",
      updatedBy: {},

      cargo: {
        //
        invoiceValue: "string",
        invoiceValueCur: "string",
        fobValue: "string",
        weight: 0,
        volume: 0,
        description: "string",
        numberOfVehicules: 0,
        numberOfMotos: 0,
        numberOfContainerFourty: 0,
        numberOfContainerTwenty: 0,
        numberOfPkgs: 0,
        //
        containers: [],
        vehicles: [],
        packages: [
          // {
          //   type: "",
          //   size: "",
          //   quantity: 0,
          //   weight: 0,
          //   content: "",
          // },
        ],
        packaging: "",
        products: [
          // {
          //   hsCode: "",
          //   weight: 0,
          //   value: "",
          //   valueCur: "",
          // },
        ],
      },
    };
    if (props.mode === "create") {
      _data.mode = props.b_mode;
      _data.sens = props.sens.toUpperCase();
      if (props.sens === "regule") {
        _data.sens = "IMPORT";
        _data.isRegul = true;
      }
    }

    let _refDocFile = props.bescId ? besc.refDocFile : 0;
    let _commercialFile = props.bescId ? besc.commercialFile : 0;
    let _fretFile = props.bescId ? besc.fretFile : 0;
    let _packingListFile = props.bescId ? besc.packingListFile : 0;
    let _originCertificateFile = props.bescId ? besc.originCertificateFile : 0;
    let _specialAuthorisationFile = props.bescId
      ? besc.specialAuthorisationFile
      : 0;
    let _exonerationFile = props.bescId
      ? besc.exoneration && besc.exoneration.exonerationFile
      : 0;
    let _other = props.bescId ? besc.otherFiles : [];

    //setLoading(true);
    //setOpen(true);
    //document.body.style.opacity = 0.5;
    //(async () => {
    let _num = 0;

    for (const [index, f] of fch.entries()) {
      if (f) {
        _num = _num + 1;
      }
    }

    setFeedback({ ...feedback, ["bdOpen"]: true });

    for (const [index, f] of fch.entries()) {
      console.log(index + 1, "th loop");
      if (f) {
        console.log("creating new file");
        console.log("fichier : ", fichiers[index]);
        setFileProgress(index + 1);
        switch (fichiers[index]["types"]) {
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_ref",
          ):
            console.log("its a refdoc file");
            _refDocFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_commercial",
          ):
            console.log("its a commercial file");
            _commercialFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_fret",
          ):
            console.log("its a fret file");
            _fretFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_packing_list",
          ):
            console.log("its a packaging list file");
            _packingListFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_certificate_origin",
          ):
            console.log("its a certificate of origin file");
            _originCertificateFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_special_authorization",
          ):
            console.log("its a special authorization file");
            _specialAuthorisationFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          case formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ):
            console.log("its an exoneration file");
            _exonerationFile = {
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            };
            break;
          default:
            console.log("its another file");
            //_id = await postFichier(f);
            _other.push({
              filename: fichiers[index]["nom"],
              data: b64[index].toString(),
              isLink: true,
            });
            break;
        }
      } else {
        console.log("file was already present we will keep reference");
      }
    }

    //CHECK FOR AT LEAST ONE OTHER FILE
    console.log("_other before : ", _other);
    _other = fichiers.some((file) => file.types === "Autre") ? _other : [];
    console.log("_other after : ", _other);

    //CREATING ENTITIES
    console.log("awaiting...");
    let _chargeur = null;
    if (props.sens === "transit") {
      _chargeur = await createShipperTransit();
    } else {
      _chargeur = await createShipper();
    }
    console.log("_chargeur : ", _chargeur);
    if (createMode.chargeur && !_chargeur) {
      return;
    }
    let _fournisseur = await createForeignShipper();
    if (createMode.fournisseur && !_fournisseur) {
      return;
    }
    console.log("_fournisseur : ", _fournisseur);
    if (createMode.chargeur) {
      console.log("charegeur awaited : ", _chargeur);
      console.log("cm now : ", createMode);
      setCreateMode({ ...createMode, chargeur: false });

      if (props.sens === "transit") {
        setChargeurs({
          uuid: _chargeur.uuid,
          nom: _chargeur.name,
          tel: _chargeur.phone,
          email: _chargeur.email,
        });
      } else {
        setChargeurs([
          {
            uuid: _chargeur.uuid,
            nom: _chargeur.name,
            niu: _chargeur.taxpayer_number,
            tel: _chargeur.phone,
            email: _chargeur.email,
          },
        ]);
      }
    }

    if (createMode.fournisseur) {
      console.log("fournisseur awaited : ", _fournisseur);
      console.log("cm now : ", createMode);
      setCreateMode({ ...createMode, fournisseur: false });
      setFournisseur({
        uuid: _fournisseur.uuid,
        nom: _fournisseur.name,
        tel: _fournisseur.phone,
        email: _fournisseur.email,
      });
    }

    console.log(
      "awaited both... , shipper : ",
      _chargeur,
      " foreign_shipper : ",
      _fournisseur,
    );

    _data.refDocFile = _refDocFile;
    _data.fretFile = _fretFile;

    if (_commercialFile) {
      _data.commercialFile = _commercialFile;
    }
    if (_data.commercialFile === "") {
      delete _data.commercialFile;
    }
    if (_packingListFile) {
      _data.packingListFile = _packingListFile;
    }
    if (_originCertificateFile) {
      _data.originCertificateFile = _originCertificateFile;
    }
    if (_specialAuthorisationFile) {
      _data.specialAuthorisationFile = _specialAuthorisationFile;
    }
    if (_exonerationFile) {
      if (props.bescId && besc.exoneration) {
        _data.exoneration = {
          "@id": besc.exoneration["@id"],
          exonerationFile: _exonerationFile,
        };
      } else {
        _data.exoneration = {
          exonerationFile: _exonerationFile,
        };
      }
    }
    _data.otherFiles = _other;

    //SUPPRESSION DES FICHIERS
    let _keys = {
      refDocFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_ref",
      ),
      commercialFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_commercial",
      ),
      fretFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_fret",
      ),
      packingListFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_packing_list",
      ),
      certificatEmpotageFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_packing_certificate",
      ),
      vgmFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_vgm",
      ),
      originCertificateFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_certificate_origin",
      ),
      specialAuthorisationFile: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_special_authorization",
      ),
      exoneration: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_exoneration",
      ),
    };

    if (props.mode !== "create") {
      for (const [_k, _val] of Object.entries(_keys)) {
        if (
          filesCopy.find((file) => file.types === _val) &&
          !fichiers.find((file) => file.types === _val)
        ) {
          console.log("there was the property ", _k, " so it must be null now");
          _data[_k] = null;
        }
      }
    }
    console.log("final payload : ", _data);

    for (let t of transactions) {
      _data.commercialTransactions.push({
        numeroTransaction: t.transaction,
        numeroContribuable: t.contribuable,
      });
    }

    _data.referenceDocNumber = transport.connaissement;
    _data.vessel = transport.navire.uuid;
    _data.carrier = transport.transporteur.uuid;
    _data.countryOfOrigin = transport.paysOrigine.code;
    // _data.countryOfTransit =
    //   transport.paysTransit && transport.paysTransit.code;
    _data.finalDestination = transport.destinationFinale.code;
    _data.countryOfLoading = transport.portEmbarquement.countryCode;
    _data.portOfLoading = transport.portEmbarquement.code;
    _data.countryOfDischarge = transport.portDebarquement.countryCode;
    _data.portOfDischarge = transport.portDebarquement.code;
    _data.conditionnement = marchandise.cond.toLowerCase();

    _data.fraisSup = transport.supp.toString();
    _data.fraisSupCur = transport.deviseSupp;
    if (
      ["ro-ro", "conteneur"].includes(_data.conditionnement) ||
      props.sens === "transit"
    ) {
      _data.classeTarifaire = null;
    } else {
      _data.classeTarifaire = marchandise.typeMarchandise;
    }

    // _data.countryOfTransit = /*TODO*/ "AM";
    _data.tarificationZone = "xxx";
    _data.baf = transport.baf.toString();
    _data.bafCur = transport.deviseBaf;
    _data.caf = transport.caf.toString();
    _data.cafCur = transport.deviseCaf;
    _data.thc = transport.thc.toString();
    _data.thcCur = transport.deviseTHC;
    _data.tempRef = tempRef;
    if (!hasRef) {
      delete _data.tempRef;
    }
    if (_data.classeTarifaire === "") {
      delete _data.classeTarifaire;
    }

    _data.referenceDocChildNumber = groupingFile.bl;
    _data.refDocChildFile = {
      data: groupingFile.b64,
      filename: groupingFile.name,
      isLink: true,
    };
    //finalDestination = string",
    if (!isGroup) {
      _data.referenceDocChildNumber = null;
      _data.refDocChildFile = null;
    }
    let de = new Date(transport.dateEmbarquement);
    _data.loadedAt = de.toISOString();
    // dischargedAt = 2024-01-24T06:21:19.896Z",
    if (transport.dateEstArrivee) {
      let eta = new Date(transport.dateEstArrivee);
      _data.eta = eta.toISOString();
    }

    // etd = 2024-01-24T06:21:19.896Z",
    _data.incoterm = transport.incoterm;
    _data.voyage = transport.numVoyage;
    _data.freight = transport.fret.toString();
    _data.freightCur = transport.deviseFret;
    _data.insurance = transport.assurance.toString();
    _data.insuranceCur = transport.deviseAssurance;
    // shipper": {
    //     realName = string",
    //     identity = string"
    // },
    if (props.bescId) {
      _data.cargo["@id"] = "/api/cargos/" + besc.cargo.id;
    }
    _data.cargo.weight = parseFloat(marchandise.poids);
    _data.cargo.volume = parseFloat(marchandise.volume);
    _data.cargo.description = marchandise.description;
    _data.cargo.invoiceValue = parseFloat(marchandise.cvalue);
    _data.cargo.invoiceValueCur = marchandise.ccurrency;
    _data.cargo.fobValue = parseFloat(marchandise.fvalue);
    _data.cargo.numberOfVehicules = parseInt(marchandise.nbchassis);
    _data.cargo.numberOfMotos = parseInt(marchandise.nbmotos);
    _data.cargo.numberOfContainerFourty = parseInt(marchandise.nbcont40);
    _data.cargo.numberOfContainerTwenty = parseInt(marchandise.nbcont20);
    _data.cargo.numberOfPkgs = parseInt(marchandise.nbcolis);

    if (props.sens !== "transit") {
      for (const [index, c] of chargeurs.entries()) {
        if (props.bescId) {
          console.log("c for chargeur : ", c);
          if (besc.consignees.length > 0) {
            _data.consignees.push({
              "@id": "/api/consignees/" + besc.consignees[index].id,
              uuid: createMode.chargeur ? _chargeur.uuid : c.uuid,
            });
          } else {
            _data.consignees.push({
              uuid: createMode.chargeur ? _chargeur.uuid : c.uuid,
            });
          }
        } else {
          _data.consignees.push({
            uuid: createMode.chargeur ? _chargeur.uuid : c.uuid,
          });
        }
      }
    } else {
      if (props.bescId) {
        if (besc.consignees.length > 0) {
          _data.consignees.push({
            "@id": "/api/consignees/" + besc.consignees[0].id,
            uuid: createMode.chargeur ? _chargeur.uuid : chargeurs.uuid,
          });
        } else {
          _data.consignees.push({
            uuid: createMode.chargeur ? _chargeur.uuid : chargeurs.uuid,
          });
        }
      } else {
        _data.consignees.push({
          uuid: createMode.chargeur ? _chargeur.uuid : chargeurs.uuid,
        });
      }
    }

    if (props.sens !== "transit") {
      _data.shipper = createMode.chargeur ? _chargeur.uuid : chargeurs[0].uuid;
    } else {
      _data.shipper = createMode.chargeur ? _chargeur.uuid : chargeurs.uuid;
    }

    _data.foreignShipper = createMode.fournisseur
      ? _fournisseur.uuid
      : fournisseur.uuid;

    console.log("details Conteneurs : ", detailsConteneur);
    for (const [index, c] of detailsConteneur.entries()) {
      console.log("current container c : ", c);
      if (props.bescId && c.id) {
        _data.cargo.containers.push({
          "@id": "/api/containers/" + c.id,
          type: c.type,
          size: c.taille,
          vgm: parseFloat(c.poids),
          loading: c.chargement,
          content: c.contenu,
          number: c.ncont,
          seal: c.nplomb,
        });
      } else {
        _data.cargo.containers.push({
          type: c.type,
          size: c.taille,
          vgm: parseFloat(c.poids),
          loading: c.chargement,
          content: c.contenu,
          number: c.ncont,
          seal: c.nplomb,
        });
      }
    }
    for (const [index, c] of detailsChassis.entries()) {
      if (props.bescId && c.id) {
        console.log("C : ", c);
        let dc = c.annee ? new Date(c.annee) : null;
        let _dc = dc ? dc.toISOString() : null;
        _data.cargo.vehicles.push({
          "@id": "/api/vehicles/" + c.id,
          brand: c.marque,
          model: c.modele,
          chassisNumber: c.nchassis,
          content: c.contenu,
          weight: "0",
          grayCard: c.b64
            ? {
                filename: c.cartegrise,
                data: c.b64,
                isLink: true,
              }
            : null,
          dateOfCirculation: _dc,
        });
      } else {
        let dc = c.annee ? new Date(c.annee) : null;
        console.log("annee : ", c.annee);
        console.log("dc : ", dc);
        let _dc = dc ? dc.toISOString() : null;
        _data.cargo.vehicles.push({
          brand: c.marque,
          model: c.modele,
          chassisNumber: c.nchassis,
          content: c.contenu,
          weight: "0",
          grayCard: c.b64
            ? {
                filename: c.cartegrise,
                data: c.b64,
                isLink: true,
              }
            : null,
          dateOfCirculation: _dc,
        });
      }
    }
    for (const [index, c] of SH.entries()) {
      if (props.bescId && c.id) {
        _data.cargo.products.push({
          "@id": "/api/products/" + c.id,
          hsCode: c.code,
          libelle: c.products,
          weight: parseFloat(c.weight),
          value: parseFloat(c.value),
          valueCur: c.curr,
        });
      } else {
        _data.cargo.products.push({
          hsCode: c.code,
          libelle: c.products,
          weight: parseFloat(c.weight),
          value: parseFloat(c.value),
          valueCur: c.curr,
        });
      }
    }
    _data.createdBy = {
      uuid: role.user["unique_identification"],
      companyUuid: role.user.company["unique_identification"],
      name: role.user.name + " " + role.user.surname,
      companyName: role.user.company.raison_sociale,
      isConsignataireVehicule: !!(
        role &&
        role.user &&
        role.user.company.consignataire
      ),
    };

    if (props.bescId) {
      _data.updatedBy = {
        uuid: role.user["unique_identification"],
      };
    } else {
      delete _data.updatedBy;
    }

    setJsonData(_data);

    let config =
      props.mode === "create"
        ? {
            method: "post",
            maxBodyLength: Infinity,
            url: MONOLITH_API_URL + "/api/bescs",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
            },
            data: JSON.stringify(_data),
          }
        : {
            method: "put",
            maxBodyLength: Infinity,
            url: MONOLITH_API_URL + "/api/bescs/" + props.bescId,
            headers: {
              "Content-Type": "application/ld+json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
            },
            data: JSON.stringify(_data),
          };
    let _data2 = { ..._data };
    delete _data2.refDocFile;
    delete _data2.commercialFile;
    delete _data2.fretFile;

    console.log("config : ", config);

    console.log("data without files : ", _data2);

    // let _message = "BESC en cours de création...";

    // setFeedback({ ...feedback, ["bdOpen"]: true });
    // let sb = notify(
    //   _message,
    //   "info",
    //   "center",
    //   "bottom",
    //   false,
    //   enqueueSnackbar
    // );
    let sb = notify(
      props.bescId
        ? "Modification du BESC en cours..."
        : "Création du BESC en cours...",
      "info",
      "center",
      "bottom",
      false,
      enqueueSnackbar,
    );

    axios
      .request(config)
      .then((response) => {
        console.log("sucess!! response below :");
        console.log(response.data);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        notify(
          props.bescId ? "BESC modifié avec succès" : "BESC créé avec succès",
          "success",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );

        history.push("/Show/" + response.data.id);
      })
      .catch((error) => {
        console.log("error!! error below :");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        let _message = error.response
          ? error.response.data["title"] + ", " + error.response.data["detail"]
          : error.message;
        notify(
          formatError(error),
          "error",
          "center",
          "top",
          true,
          enqueueSnackbar,
        );
        // setFeedback({ ...feedback, ["bdOpen"]: false });
        // closeSnack(sb, closeSnackbar);
        // notify(error, "error", "center", "top", true, enqueueSnackbar);
      });

    //})();
  };

  useEffect(() => {
    console.log("besc changed  : ", besc);
    if (besc.tempRef && besc.tempRef.id) {
      setHasRef(true);
      setTempRef(besc.tempRef["@id"]);
    }

    if (besc.refDocChildFile) {
      setIsGroup(true);
      setGroupingFile({
        bl: besc.referenceDocChildNumber,
        name: besc.refDocChildFile.filename,
        b64: besc.refDocChildFile.data,
      });
    }
  }, [besc]);

  useEffect(() => {
    console.log("createMode sent(CREATION BESC) : ", createMode);
  }, [createMode]);

  useEffect(() => {
    console.log("partnersData sent : ", partnersData);
    //SETTING OTHER FIELDS

    //APPEL A COMPLETE INFOS
  }, [partnersData]);

  useEffect(() => {
    console.log("b64 sent : ", b64);
  }, [b64]);

  useEffect(() => {
    console.log("fichiers sent : ", fichiers);
  }, [fichiers]);

  useEffect(() => {
    console.log("chargeurs sent : ", chargeurs);
  }, [chargeurs]);

  useEffect(() => {
    console.log("fournisseur sent : ", fournisseur);
  }, [fournisseur]);

  useEffect(() => {
    console.log("marchandise sent : ", marchandise);
  }, [marchandise]);

  useEffect(() => {
    console.log("transactions sent : ", transactions);
  }, [transactions]);

  useEffect(() => {
    console.log("detailsConteneur sent : ", detailsConteneur);
  }, [detailsConteneur]);

  useEffect(() => {
    console.log("SH sent : ", SH);
  }, [SH]);

  useEffect(() => {
    console.log("detailsChassis sent : ", detailsChassis);
  }, [detailsChassis]);

  useEffect(() => {
    console.log("transport sent : ", transport);
  }, [transport]);

  return (
    <>
      <Fragment>
        <Grid container direction="row" spacing={2} xs={12}>
          {role.user &&
            [
              "Chargeur Principal",
              "Sous Compte Chargeur",
              "Chargeur Secondaire",
            ].includes(role.user.roles[0].name) &&
            props.sens !== "transit" && (
              <Grid item xs={4} alignContent="center" alignItems="center">
                <FormControl component="fieldset" variant="standard">
                  <FormGroup>
                    <FormControlLabel
                      component="legend"
                      control={
                        <Switch
                          checked={isGroup}
                          onChange={() => {
                            setIsGroup(!isGroup);
                          }}
                          name="toggleLock"
                        >
                          A
                        </Switch>
                      }
                      label={
                        <Typography color="textPrimary">
                          {formatMessage(intl, "create_besc_is_grouped")}
                        </Typography>
                      }
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
          {role.user &&
            [
              "Chargeur Principal",
              "Sous Compte Chargeur",
              "Chargeur Secondaire",
            ].includes(role.user.roles[0].name) &&
            props.sens !== "transit" &&
            !(besc.tempRef && besc.tempRef.id) && (
              <>
                <Grid item xs={4} alignContent="center" alignItems="center">
                  <FormControl component="fieldset" variant="standard">
                    <FormGroup>
                      <FormControlLabel
                        component="legend"
                        control={
                          <Switch
                            checked={
                              besc.tempRef && besc.tempRef.id ? true : hasRef
                            }
                            onChange={() => {
                              setHasRef(!hasRef);
                            }}
                            name="toggleLock"
                          >
                            A
                          </Switch>
                        }
                        label={
                          <Typography color="textPrimary">
                            {formatMessage(intl, "create_besc_has_reference")}
                          </Typography>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </>
            )}
          {hasRef && (
            <Grid item xs={12} sm={8} md={4}>
              <FormControl
                fullWidth
                size="small"
                className={classes.margin}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-amount">
                  {formatMessage(intl, "create_besc_label_reference")}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  value={
                    besc.tempRef && besc.tempRef.id
                      ? besc.tempRef.ref
                      : reference
                  }
                  readOnly={besc.tempRef && besc.tempRef.id}
                  onChange={(event) => handleChangeRef(event)}
                  labelWidth={180}
                  disabled={checkingRef}
                  error={refError}
                  startAdornment={
                    checkingRef && (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    )
                  }
                  endAdornment={
                    refOK && <CheckIcon style={{ color: green[500] }} />
                  }
                />
                <FormHelperText error>{refHelper}</FormHelperText>
              </FormControl>
            </Grid>
          )}
        </Grid>
        <Grid
          container
          direction="column"
          justifyContent="center"
          spacing={2}
          xs={12}
        >
          <Grid item>
            <ExpansionPanel
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography>
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_files",
                  )}
                  {filesLoading && <CircularProgress size={20} />}
                  {filesFilled && <CheckIcon style={{ color: green[500] }} />}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  spacing={2}
                  xs={12}
                >
                  <Fichiers
                    {...props}
                    setValidity={(valid) => setFilesFilled(valid)}
                    sendFichiers={(_props) => setFichiers(_props)}
                    sendFch={(_props) => setFch(_props)}
                    sendB64={(_props) => setB64(_props)}
                    conditionnement={conditionnement}
                    data={files}
                  />
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <>
              {props.sens !== "transit" && (
                <ExpansionPanel
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                  >
                    <Typography>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_transaction",
                      )}
                      {transactionsLoading && <CircularProgress size={20} />}
                      {(transactionsFilled ||
                        (props.sens !== "regule" &&
                          chargeursFilled &&
                          fournisseurFilled)) && (
                        <CheckIcon style={{ color: green[500] }} />
                      )}
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      spacing={2}
                      xs={12}
                    >
                      <Transactions
                        {...props}
                        setValidity={(valid) => setTransactionsFilled(valid)}
                        sendTransactions={(_props) => setTransactions(_props)}
                        sendPartnersData={(_props) => setPartnersData(_props)}
                        api={MASTER_API_URL}
                        data={transactions}
                        chargeurs={chargeurs}
                      />
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              )}
              <ExpansionPanel
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="pane21bh-content"
                  id="pane21bh-header"
                >
                  <Typography>
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_shippers",
                    )}
                    {shippersLoading && <CircularProgress size={20} />}
                    {chargeursFilled && fournisseurFilled && (
                      <CheckIcon style={{ color: green[500] }} />
                    )}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {/* -------------------------------------- Chargeurs et destinataires ----------------------------------- */}
                  {["import", "regule"].includes(props.sens) ? (
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      spacing={2}
                      xs={12}
                    >
                      <Chargeurs
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_recipient",
                        )}
                        setValidity={(valid) => setChargeursFilled(valid)}
                        sendChargeurs={(_props) => setChargeurs(_props)}
                        sendCreateMode={(_props) => {
                          console.log(
                            "from child(chargeur sendCreateMode) with props : ",
                            _props,
                          );
                          console.log("old cm : ", createMode);
                          setCreateMode({
                            ...createMode,
                            ["chargeur"]: _props,
                          });
                        }}
                        api={MASTER_API_URL}
                        data={chargeurs}
                        cMode={createMode.chargeur}
                        partnersData={partnersData}
                        setLoading={setShippersLoading}
                      />

                      <Fournisseur
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_sender",
                        )}
                        formId="fournisseur-form"
                        setValidity={(valid) => setFournisseurFilled(valid)}
                        sendFournisseur={(_props) => setFournisseur(_props)}
                        sendCreateMode={(_props) => {
                          console.log(
                            "from child(fournisseur sendCreateMode) with props : ",
                            _props,
                          );
                          console.log("old cm : ", createMode);
                          setCreateMode({
                            ...createMode,
                            ["fournisseur"]: _props,
                          });
                        }}
                        api={MASTER_API_URL}
                        data={fournisseur}
                        cMode={createMode.fournisseur}
                      />
                    </Grid>
                  ) : props.sens === "transit" ? (
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      spacing={2}
                      xs={12}
                    >
                      <Fournisseur
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_recipient",
                        )}
                        formId="chargeur-form"
                        setValidity={(valid) => setChargeursFilled(valid)}
                        sendFournisseur={(_props) => setChargeurs(_props)}
                        sendCreateMode={(_props) => {
                          console.log(
                            "from child(chargeur sendCreateMode) with props : ",
                            _props,
                          );
                          console.log("old cm : ", createMode);
                          setCreateMode({
                            ...createMode,
                            ["chargeur"]: _props,
                          });
                        }}
                        api={MASTER_API_URL}
                        data={chargeurs}
                        cMode={createMode.chargeur}
                      />

                      <Fournisseur
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_sender",
                        )}
                        formId="fournisseur-form"
                        setValidity={(valid) => setFournisseurFilled(valid)}
                        sendFournisseur={(_props) => setFournisseur(_props)}
                        sendCreateMode={(_props) => {
                          console.log(
                            "from child(fournisseur sendCreateMode) with props : ",
                            _props,
                          );
                          console.log("old cm : ", createMode);
                          setCreateMode({
                            ...createMode,
                            ["fournisseur"]: _props,
                          });
                        }}
                        api={MASTER_API_URL}
                        data={fournisseur}
                        cMode={createMode.fournisseur}
                      />
                    </Grid>
                  ) : (
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      spacing={2}
                      xs={12}
                    >
                      <Fournisseur
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_recipient",
                        )}
                        formId="fournisseur-form"
                        setValidity={(valid) => setFournisseurFilled(valid)}
                        sendCreateMode={(_props) =>
                          setCreateMode({
                            ...createMode,
                            ["fournisseur"]: _props,
                          })
                        }
                        sendFournisseur={(_props) => setFournisseur(_props)}
                        api={MASTER_API_URL}
                        data={fournisseur}
                      />
                      <Chargeurs
                        {...props}
                        headTitle={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_shippers_card_sender",
                        )}
                        setValidity={(valid) => setChargeursFilled(valid)}
                        sendChargeurs={(_props) => setChargeurs(_props)}
                        sendCreateMode={(_props) => setCreateMode(_props)}
                        api={MASTER_API_URL}
                        data={chargeurs}
                        partnersData={partnersData}
                        setLoading={setShippersLoading}
                      />
                    </Grid>
                  )}
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </>

            <ExpansionPanel
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <Typography>
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_cargo",
                  )}
                  {cargaisonLoading && <CircularProgress size={20} />}
                  {!cargaisonLoading && cargaisonFilled && SH.length > 0 && (
                    <CheckIcon style={{ color: green[500] }} />
                  )}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {/* -------------------------------------- Cargaison ----------------------------------- */}
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  spacing={2}
                  xs={12}
                >
                  <Cargaison
                    {...props}
                    setValidity={(valid) => setCargaisonFilled(valid)}
                    sendMarchandise={(_props) => setMarchandise(_props)}
                    sendDetailsConteneur={(_props) =>
                      setDetailsConteneur(_props)
                    }
                    setConditionnement={setConditionnement}
                    sendDetailsChassis={(_props) => setDetailsChassis(_props)}
                    sendSH={(_props) => setSH(_props)}
                    api={MASTER_API_URL}
                    data={{
                      marchandise: marchandise,
                      detailsConteneur: detailsConteneur,
                      detailsChassis: detailsChassis,
                      sh: SH,
                    }}
                    received22={received22}
                  />
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4bh-content"
                id="panel4bh-header"
              >
                <Typography>
                  {formatMessage(
                    intl,
                    "create_besc_maritime_import_accordion_transport",
                  )}
                  {transportLoading && <CircularProgress size={20} />}
                  {transportFilled && (
                    <CheckIcon style={{ color: green[500] }} />
                  )}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {/* -------------------------------------- Contrat de transport ----------------------------------- */}
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  spacing={2}
                  xs={12}
                >
                  <Transport
                    {...props}
                    setValidity={(valid) => setTransportFilled(valid)}
                    sendTransport={(_props) => setTransport(_props)}
                    bescId={props.bescId}
                    isGroup={isGroup}
                    setCarrier={setCarrier}
                    conditionnement={conditionnement}
                    api={MASTER_API_URL}
                    data={transport}
                    createMode={createMode}
                    sendCreateMode={(_props) =>
                      setCreateMode({
                        ...createMode,
                        ["transporteur"]: _props.transporteur,
                        ["navire"]: _props.navire,
                      })
                    }
                  />
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            {isGroup && (
              <ExpansionPanel
                expanded={expanded === "panel6"}
                onChange={handleChange("panel6")}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel6bh-header"
                >
                  <Typography>
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_grouping",
                    )}
                    {groupingFilesLoading && <CircularProgress size={20} />}
                    {groupingFilesFilled && (
                      <CheckIcon style={{ color: green[500] }} />
                    )}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    spacing={2}
                    xs={12}
                  >
                    <Groupage
                      {...props}
                      setValidity={(valid) => setGroupingFilesFilled(valid)}
                      conditionnement={conditionnement}
                      carrier={carrier}
                      bescId={props.bescId}
                      sendFile={(_props) => setGroupingFile(_props)}
                      data={groupingFile}
                    />
                  </Grid>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            )}
          </Grid>

          <Grid item>
            <Button
              // disabled={
              //   !(
              //     chargeurs ||
              //     fournisseur ||
              //     detailsChassis ||
              //     detailsConteneur ||
              //     transport
              //   )
              // }
              onClick={submitForm}
              disabled={
                (!(besc.tempRef && besc.tempRef.id) && hasRef && !refOK) ||
                (isGroup && !groupingFilesFilled) ||
                !filesFilled ||
                !chargeursFilled ||
                !fournisseurFilled ||
                (props.sens === "regule" && !transactionsFilled) ||
                !cargaisonFilled ||
                SH.length == 0 ||
                !transportFilled
              }
              variant="contained"
              color="primary"
            >
              {props.mode === "create"
                ? formatMessage(intl, "create_besc_maritime_import_btn_create")
                : formatMessage(intl, "create_besc_maritime_import_btn_edit")}
            </Button>
          </Grid>
        </Grid>

        <Button
          hidden
          onClick={async () => {
            console.log("chargeurs : ", chargeurs);
            console.log("fournisseur : ", fournisseur);
            console.log("LANCEMENT DES CREATIONS");
            let _chargeur = await createShipper();
            let _fournisseur = await createForeignShipper();
            if (createMode.chargeur) {
              console.log("charegeur awaited : ", _chargeur);
              console.log("cm now : ", createMode);
              setCreateMode({ ...createMode, chargeur: false });
              setChargeurs([
                {
                  uuid: _chargeur.uuid,
                  nom: _chargeur.name,
                  niu: _chargeur.taxpayer_number,
                  tel: _chargeur.phone,
                  email: _chargeur.email,
                },
              ]);
            }

            if (createMode.fournisseur) {
              console.log("fournisseur awaited : ", _fournisseur);
              console.log("cm now : ", createMode);
              setCreateMode({ ...createMode, fournisseur: false });
              setFournisseur({
                uuid: _fournisseur.uuid,
                nom: _fournisseur.name,
                tel: _fournisseur.phone,
                email: _fournisseur.email,
              });
            }
          }}
          variant="outlined"
          color="secondary"
          type="submit"
        >
          Lancer les créations
        </Button>

        <Button
          hidden
          onClick={() => {
            console.log(
              "chargeursFilled  : ",
              chargeursFilled,
              " fournisseurFilled : ",
              fournisseurFilled,
            );
          }}
          variant="outlined"
          color="secondary"
          type="submit"
        >
          AssertFillage
        </Button>
      </Fragment>

      {/* <Snackbar open={open} onClose={handleClose}>
        <Alert onClose={handleClose} severity="info">
          {props.bescId
            ? "Modification du BESC en cours..."
            : "Création du BESC en cours..."}
        </Alert>
      </Snackbar>

      <Snackbar open={done} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          BESC crée avec succès
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop> */}
    </>
  );
};

export default LivePreviewExample;
